import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CardType, CountryHN, PersonalLoanType } from 'src/app/@core/constants';
import { InputUtils } from 'src/app/@core/utils/input-utils';
import { Bank } from 'src/app/models/bank';
import { AdvanceFilter } from 'src/app/models/filters/advance-filter';
import { PaymentMethod } from 'src/app/models/payment-method';
import { PaymentMethodType } from 'src/app/models/payment-method-type';
import { AdvanceService } from 'src/app/services/advance.service';
import { BankService } from 'src/app/services/bank.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ExceptionSolutionService } from 'src/app/services/exception-solution.service';
import { ExchangeRateService } from 'src/app/services/exchange-rate.service';
import { GiftCardService } from 'src/app/services/giftcard.service';
import { LoyaltyPointsService } from 'src/app/services/loyalty-points.service';
import { OpenItemsService } from 'src/app/services/open-items.service';
import { ParamsService } from 'src/app/services/params.service';
import { SalesService } from 'src/app/services/sales.service';
import { VoucherService } from 'src/app/services/voucher.service';
import { Filter } from '../../../models/filter';

@Component({
  selector: 'app-add-payment-modal',
  templateUrl: './add-payment-modal.component.html',
  styleUrls: ['./add-payment-modal.component.sass']
})
export class AddPaymentModalComponent implements OnInit {

  readonly CASH_CODE = "ZE01";
  readonly CASH_CODE_USD = "ZE02";
  private readonly USD = "USD";
  private readonly LOYALTY = "PL";
  private readonly GIFT_CARD = "GC";
  private readonly ADVANCE = "AT";
  private readonly CHEQUE = "CH";
  private readonly NOTA_CAMBIO = "NCA";
  private readonly VALE = "VDC";
  private readonly PAC = "PAC";
  private readonly NCR = "NCR";
  private readonly MAX_POINTS_PERCENTAGE = 0.2;
  paymentMethod: PaymentMethod = new PaymentMethod();
  paymentList: Array<PaymentMethod> = [];
  totalAmount = 0;
  creditLimitAmount = 0;
  customerCode = "";
  totalIsvPaymentCard = 0;
  totalPaymentCard = 0;
  totalWithIsvPaymentCard = 0;
  paymentsAmount = 0;
  exchangeRate = 0;
  totalPointsOfSelectedClient = 0;
  maxQuantityPointsCanUse = 0;
  _amount?: number = undefined;
  percentageTaxes: String = "";

  set amount(amount: number | undefined) {
    this._amount = amount ? Number(amount) : undefined;
  }

  get amount(): number | undefined {
    return this._amount;
  }
  bankList: Array<Bank> = [];
  personalLoanTerms: Array<string> = [];
  activeSalesOrgPersonalLoan: Array<string> = [];
  creditCardTypesArray = [
    { code: CardType.AMEX, nameToShow: 'American Express' },
    { code: CardType.MASTERCARD, nameToShow: 'MasterCard' },
    { code: CardType.VISA, nameToShow: 'Visa' },
    { code: CardType.DISCOVER, nameToShow: 'Discover' },
    { code: CardType.DINERS, nameToShow: 'Diners' },
    { code: CardType.OTRA, nameToShow: 'Otras' }
  ];
  confirmAction: () => any = () => { };

  constructor(
    private bsModalRef: BsModalRef,
    private exchangeRateService: ExchangeRateService,
    private loyaltyPointsService: LoyaltyPointsService,
    private giftCardService: GiftCardService,
    private advanceService: AdvanceService,
    private configurationService: ConfigurationService,
    private openItemsService: OpenItemsService,
    private voucherService: VoucherService,
    private salesService: SalesService,
    private readonly exceptionSolutionService: ExceptionSolutionService,
    private bankService: BankService,
    private paramsService: ParamsService) { }

  async ngOnInit(): Promise<void> {
    this.paymentMethod.paymentMethodCode = this.paymentMethod.methods[0]?.code || '';
    this.paymentMethod.currency = this.paymentMethod.methods[0]?.currency || "HNL";
    if (this.paymentMethod.currency === this.USD) {
      this.exchangeRate = (await this.exchangeRateService.readLatestExchangeRate()).rate;
    }

    if (this.paymentMethod.code === this.LOYALTY) {
      const customer = (await this.loyaltyPointsService.getLoyaltyPointsByCustomerCode(this.customerCode).toPromise()).response.content;
      console.log(customer);
      const today = new Date();
      customer[0]?.points.forEach(point => {
        // format: YYYYMMDD
        const expiration = point.expirationDate;
        const year = +expiration.substring(0, 4);
        const month = +expiration.substring(4, 6);
        const day = +expiration.substring(6);
        const expirationDate = new Date(year, month - 1, day);
        if (today <= expirationDate) {
          this.totalPointsOfSelectedClient += point.amount;
        }
      });

      if (this.totalPointsOfSelectedClient >= (this.totalAmount * 0.2)) {
        this.maxQuantityPointsCanUse = this.round(this.MAX_POINTS_PERCENTAGE * this.totalAmount);
      } else {
        this.maxQuantityPointsCanUse = this.totalPointsOfSelectedClient;
      }
    }

    if (this.paymentMethod.code === this.CHEQUE) {
      this.bankList = (await this.bankService.getBankList().toPromise()).response.content;
      this.bankList = this.bankList.filter(bank => bank.country === CountryHN);
    }

    if (this.paymentMethod.style == "CARD") {
      this.personalLoanTerms = (await this.paramsService.readParam("personal-loan-term-lists").toPromise()).response.value.split(",");
    }

    this.activeSalesOrgPersonalLoan = (await this.paramsService.readParam("personal-loan-included-salesOrgs").toPromise()).response.value.split(",");

    this.percentageTaxes = (await this.paramsService.readParam("percentage-taxes-payments-with-card").toPromise()).response.value;
  }

  cancel(): void {
    this.bsModalRef.hide();
  }

  onlyNumbers(event: any): boolean {

    return InputUtils.onlyNumbers(event);
  }

  calculateISVPayment(event: any) {
    this.totalIsvPaymentCard = 0;
    this.totalPaymentCard = 0;
    this.totalWithIsvPaymentCard = 0;


    if (event.target.value) {
      const total: number = this.amount ?? 0;
      const per: number = Number(this.percentageTaxes ? this.percentageTaxes : 15);
      this.totalWithIsvPaymentCard = total;
      this.totalIsvPaymentCard = total - (total / (1 + (per / 100)));
      this.totalPaymentCard = total / (1 + (per / 100));
    }
  }

  getPaymentUSD(): number {
    const amount = this.totalAmount - this.paymentsAmount;
    const total = amount / this.exchangeRate;
    const ceil = this.ceilNumber(total, 2);
    const newNumber = this.round(ceil);
    return newNumber;
  }

  switchCardType(event: any, value: CardType): void {
    event.preventDefault();
    this.paymentMethod.cardType = value;
  }

  ceilNumber(rnum: number, rlength: number): number {
    const newnumber = Math.ceil(rnum * Math.pow(10, rlength)) / Math.pow(10, rlength);
    return newnumber;
  }

  async addPayment(): Promise<void> {

    const idx = this.paymentList.findIndex(payment => payment.code == this.paymentMethod.code && (payment.identifier ?? "") == this.paymentMethod.identifier);
    if (idx !== -1) {
      this.exceptionSolutionService.showAlertWithSolution(`Pagar`, `Ya existe un método de pago con este identificador.`, undefined, 'error');
      return;
    }

    if (this.paymentMethod.code === this.GIFT_CARD) {
      const giftCard = (await this.giftCardService.readGiftCard(this.paymentMethod.identifier).toPromise()).response
      if (giftCard) {
        if (this.amount! > giftCard.amount) {
          this.exceptionSolutionService.showAlertWithSolution(`Pagar`, `El monto que ingreso ${this.amount} es mayor a la giftcard ${giftCard.amount}.`, undefined, 'error');
          return;
        }
      } else {
        this.exceptionSolutionService.showAlertWithSolution(`Pagar`, `La Giftcard no existe.`, undefined, 'error');
        return;
      }
    }

    if (this.paymentMethod.code === this.ADVANCE) {
      const salesOrgObject = this.configurationService.readSelectedBranchAndSalesOrg().salesOrg;
      const filter: Filter<AdvanceFilter> = {
        page: 0,
        pageSize: 1,
        value: {
          receiptCode: this.paymentMethod.identifier,
          isReturn: false
        }
      };
      const advanceList = (await this.advanceService.readAdvances(filter).toPromise()).response.content;

      if (advanceList[0]) {
        advanceList[0].totalAmount = this.round(advanceList[0].totalAmount);
        if (advanceList[0].returnAdvanceCode) {
          this.exceptionSolutionService.showAlertWithSolution(`Pagar`, `El anticipo fue devuelto`, undefined, 'error');
          return;
        }
        if (advanceList[0].salesOrg !== salesOrgObject.code) {
          this.exceptionSolutionService.showAlertWithSolution(`Pagar`, `El anticipo no pertence a ${salesOrgObject.name}`, undefined, 'error');
          return;
        }
        if (advanceList[0].customerCode !== this.customerCode) {
          this.exceptionSolutionService.showAlertWithSolution(`Pagar`, `El anticipo no pertence a este cliente, pertenece al BP ${advanceList[0].customerCode}`, undefined, 'error');
          return;
        }
      } else {
        this.exceptionSolutionService.showAlertWithSolution(`Pagar`, `El anticipo no existe`, undefined, 'error');
        return;
      }
    }

    if (!this.amount) {
      this.exceptionSolutionService.showAlertWithSolution(`Pagar`, `Hubo un error al tratar de agregar el tipo de pago.`, undefined, 'error');
      return;
    }

    if (this.paymentMethod.code === this.CHEQUE) {
      if (!this.paymentMethod.bank) {
        this.exceptionSolutionService.showAlertWithSolution(`Pagar`, `Debe seleccionar un banco`, undefined, 'error');
        return;
      }

      if (!this.paymentMethod.identifier) {
        this.exceptionSolutionService.showAlertWithSolution(`Pagar`, `Agregue un número de cheque`, undefined, 'error');
        return;
      }
    }

    if (!this.verifyTotalAmount()) {
      this.exceptionSolutionService.showAlertWithSolution(`Pagar`, `El monto ${this.amount} supera el permitido para esta compra`, undefined, 'error');
      return;
    }

    if (this.paymentMethod.code === this.NOTA_CAMBIO) {
      const today = new Date();
      const todayString = today.toISOString().split("T")[0].replace(/-/g, "");

      const response = await this.openItemsService.retrieveOpenItems(todayString, this.customerCode).toPromise();
      this.createNewNotaDeCambioPayment(response);

      return;
    }

    if (this.paymentMethod.code === this.VALE) {
      if (this.paymentMethod.identifier && this.amount) {
        const salesOrgObject = this.configurationService.readSelectedBranchAndSalesOrg().salesOrg;
        const voucher = (await this.voucherService.getVoucherByCode(this.paymentMethod.identifier).toPromise()).response;
        const voucherTotalAmount = voucher.totalAmount;

        if (voucher.salesOrgCode !== salesOrgObject.code) {
          this.exceptionSolutionService.showAlertWithSolution(`Pagar`, `El vale no pertence a ${salesOrgObject.name}`, undefined, 'error');
          return;
        }

        if (voucherTotalAmount != undefined) {
          if (this.amount > voucherTotalAmount) {
            this.exceptionSolutionService.showAlertWithSolution(`Pagar`, `El monto ingresado ( L.${this.amount} ), supera el total del vale ${this.paymentMethod.identifier}. Monto actual del vale L.${voucherTotalAmount}`, undefined, 'error');
            return;
          }
        } else {
          this.exceptionSolutionService.showAlertWithSolution(`Pagar`, `Vale con error ya que no tiene un valor`, undefined, 'error');
          return;
        }

        if (voucher.customerCode !== this.customerCode) {
          this.exceptionSolutionService.showAlertWithSolution(`Pagar`, `El vale no es del mismo cliente, pertence a ${voucher.customerCode}`, undefined, 'error');
          return;
        }

      } else {
        this.exceptionSolutionService.showAlertWithSolution(`Pagar`, `Verifica que se ingresó indentificador o monto`, undefined, 'error');
        return;
      }
    }

    if (this.paymentMethod.code === this.PAC) {
      if (this.creditLimitAmount < this.amount) {
        this.exceptionSolutionService.showAlertWithSolution(`Pagar`, `El monto ${this.amount} es mayor que el límite de crédito actual del cliente ${this.creditLimitAmount}`, undefined, 'error');
        return;
      }
    }

    if (this.paymentMethod.style == "CARD") {
      if (!this.paymentMethod.personalLoanTerm && this.paymentMethod.personalLoanType != PersonalLoanType.CASH) {
        this.exceptionSolutionService.showAlertWithSolution(`Pagar`, `El campo de plazo no puede estar vacío`, undefined, 'error');
        return;
      }
    }
    if (this.paymentMethod.code === this.NCR) {
      if (!/^\d{3}-\d{3}-\d{2}-\d{8}$/.test(this.paymentMethod.identifier)) {
        this.exceptionSolutionService.showAlertWithSolution(`Pagar`, `El formato de la nota de crédito es incorrecto`, undefined, 'error');
        return;
      }

      const numberSplit = this.paymentMethod.identifier.split("-");
      if (numberSplit.length === 4) {

        const resp = await
          this.salesService.getInvoiceById(numberSplit[0], numberSplit[1], numberSplit[2], numberSplit[3]).toPromise();

        if (resp.response.content.length) {
          if (resp.response.content[0].orderType !== "RETURN") {
            this.exceptionSolutionService.showAlertWithSolution(`Pagar`, `El metodo de pago tiene que ser una Nota de Credito`, undefined, 'error');
            return;
          }
          if (resp.response.content[0].customerCode !== this.customerCode) {
            this.exceptionSolutionService.showAlertWithSolution(`Pagar`, `La nota de credito no es del mismo cliente.`, undefined, 'error');
            return;
          }

          if (!resp.response.content[0].usableAsPayment) {
            this.exceptionSolutionService.showAlertWithSolution(`Pagar`, `No se puede utilizar esta nota de credito.`, undefined, 'error');
            return;
          }

          if (!resp.response.content[0].isActivated) {
            this.exceptionSolutionService.showAlertWithSolution(`Pagar`, `No se puede utilizar la nota de credito de taller, por favor realizar proceso de activacion.`, undefined, 'error');
            return;
          }

          const amountUsedAsPayment = resp.response.content[0].amountUsedAsPayment;
          if (amountUsedAsPayment === 0) {
            this.exceptionSolutionService.showAlertWithSolution(`Pagar`, `Esta nota de crédito ya ha sido utilizada`, undefined, 'error');
            return;
          }

          if (Number(this.amount ?? 0) > amountUsedAsPayment) {
            this.exceptionSolutionService.showAlertWithSolution(`Pagar`, `La cantidad a pagar sobrepasa el valor disponible de la nota de crédito. Disponible: HNL ${amountUsedAsPayment}`, undefined, 'error');
            return;
          }

          this.paymentMethod.amount = Number(this.amount ?? 0);
          this.addPaymentToList();
          this.cancel();

        } else {
          this.exceptionSolutionService.showAlertWithSolution(`Pagar`, `No existe la nota de crédito`, undefined, 'error');
          return;
        }

      }
    } else {
      this.paymentMethod.amount = Number(this.amount ?? 0);
      this.addPaymentToList();
      this.cancel();
    }
  }

  private verifyTotalAmount(): boolean {
    const total = this.round(this.totalAmount);
    const totalP = this.round(this.paymentsAmount);
    const difer = totalP + (this.paymentMethod.currency !== this.USD ?
      this.amount! : this.round(this.amount! * this.exchangeRate));
    const finalAmount = this.round(total - difer);

    let continuePayment = false;

    if (this.amount! > 0) {

      if (this.paymentMethod.code === this.LOYALTY) {
        if (this.amount! <= this.maxQuantityPointsCanUse) {
          this.totalPointsOfSelectedClient = +this.totalPointsOfSelectedClient - +this.amount!;
          this.maxQuantityPointsCanUse = +this.maxQuantityPointsCanUse - +this.amount!;
          this.maxQuantityPointsCanUse = this.round(this.maxQuantityPointsCanUse);
          continuePayment = true;
        }
      } else {

        if (finalAmount < 0) {
          if (this.paymentMethod.code === this.CASH_CODE || this.paymentMethod.code === this.CASH_CODE_USD) {
            if (this.totalAmount > this.paymentsAmount) {
              continuePayment = true;
            }
          }
          else {
            if (this.paymentMethod.currency === this.USD) {
              const totalPermitDollar = this.ceilNumber(((this.totalAmount - this.paymentsAmount) / this.exchangeRate), 2);
              const paymentAmount = this.amount;

              if (paymentAmount! <= totalPermitDollar) {
                continuePayment = true;
              }
            }
          }
        }
        else {
          continuePayment = true;
        }
      }
    }

    return continuePayment;
  }

  private createNewNotaDeCambioPayment(result: any): void {
    if (!result.response.documents) {
      this.exceptionSolutionService.showAlertWithSolution(`Pagar`, `Hubo un error al leer los datos de la nota de cambio.`, undefined, 'error');
      return;
    }

    const nca = result.response.documents.find((document: any) => document.reference === this.paymentMethod.identifier);

    if (!nca) {
      this.exceptionSolutionService.showAlertWithSolution(`Pagar`, `No hay nota de cambio con este numero.`, undefined, 'error');
      return;
    }
    if (Number.parseFloat(nca.amount) < this.amount!) {
      this.exceptionSolutionService.showAlertWithSolution(`Pagar`, `El monto ${this.amount} supera el permitido para esta compra.`, undefined, 'error');
      return;
    }

    this.paymentMethod.amount = this.amount!;
    this.addPaymentToList();
    this.cancel();
  }

  private addPaymentToList(): void {

    if (this.paymentMethod.code !== this.CASH_CODE && this.paymentMethod.currency !== this.USD) {
      const finalAmount = this.totalAmount - this.paymentsAmount + this.paymentMethod.amount;
      if (finalAmount >= 0) {
        this.paymentMethod.applied = this.paymentMethod.amount;
      } else {
        this.exceptionSolutionService.showAlertWithSolution(`Pagar`, `Este tipo de pago no permite cambio`, undefined, 'error');
        return;
      }
    }

    let payment = new PaymentMethod().buildPaymentMethod(this.paymentMethod);
    this.paymentList.push(payment);
    this.confirmAction();
    this.paymentMethod.identifier = "";
  }

  private round(amount: number): number {
    return Math.round(amount * 100) / 100;
  }

  changePersonalLoanType(loanType: PersonalLoanType) {
    if (loanType == PersonalLoanType.CASH) {
      this.paymentMethod.personalLoanTerm = "";
    }
  }

  isPersonalLoanActiveSalesOrg() {
    return this.activeSalesOrgPersonalLoan.includes(this.configurationService.readSelectedBranchAndSalesOrg().salesOrg.code);
  }

  async changePaymentMethod(paymentMethod: PaymentMethod) {
    const method = paymentMethod.methods.find(s => s.code == paymentMethod.paymentMethodCode) ?? new PaymentMethodType();
    this.paymentMethod.currency = method.currency;
    this.paymentMethod.paymentMethodCode = method.code;
    if (method.currency == this.USD) {
      this.exchangeRate = (await this.exchangeRateService.readLatestExchangeRate()).rate;
    }
  }
}
